<div *ngIf="!isActionInProgress" class="container-fluid d-flex flex-column justify-content-center align-items-center">
  <img src="assets/chapps-logo.png" />
  <mdb-card class="mt-3">
    <mdb-card-body>
      <h4 class="text-center" [translate]="Localization.SignedOut"></h4>
      <p *ngIf="wasSignOutSuccessfull" [translate]="Localization.SignOutMessage"></p>
      <app-error-alert *ngIf="!wasSignOutSuccessfull" [message]="Localization.SignOutErrorMessage"></app-error-alert>
    </mdb-card-body>
    <mdb-card-footer class="d-flex justify-content-center">
      <button *ngIf="wasSignOutSuccessfull" appBg="primary" brightness="normal" type="button" mdbBtn mdbWavesEffect
              [translate]="Localization.LoginAgain" (click)="goToLoginPage()"></button>
      <button *ngIf="!wasSignOutSuccessfull" color="danger" type="button" mdbBtn mdbWavesEffect
              [translate]="Localization.TryAgain" (click)="signOut()"></button>
    </mdb-card-footer>
  </mdb-card>
</div>
<div class="page-spinner-no-background" *ngIf="isActionInProgress">
  <mdb-spinner spinnerType="big"></mdb-spinner>
</div>
